import { ButtonSwitch, Info, Pair } from "emukit";
import React, { FC, useCallback } from "react";

import type { GameboyEmulator } from "../../../ts";

import "./rom-section.css";

export type RomSectionProps = {
    emulator: GameboyEmulator;
    roms?: { name: string; url: string }[];
    style?: string[];
};

export const RomSection: FC<RomSectionProps> = ({
    emulator,
    roms = [],
    style = []
}) => {
    const onRomChange = useCallback(
        async (option: string) => {
            const selectedRom = roms.find((rom) => rom.name === option);
            if (!selectedRom) return;

            try {
                emulator.handlers.showToast?.(
                    `🎮 Loading ${selectedRom.name}...`
                );

                // Load the ROM from the URL
                await emulator.loadRomUrl(selectedRom.url);

                emulator.handlers.showToast?.(
                    `✅ ${selectedRom.name} loaded successfully`
                );
            } catch (error) {
                console.error("Failed to load ROM:", error);
                emulator.handlers.showToast?.(
                    `❌ Failed to load ${selectedRom.name}`
                );
            }
        },
        [emulator, roms]
    );

    const romNames = roms.map((rom) => rom.name);

    return (
        <Info>
            <Pair
                key="rom-selector"
                name={"Select ROM"}
                valueNode={
                    <ButtonSwitch
                        options={romNames}
                        value={romNames[0] || ""}
                        uppercase={false}
                        size={"large"}
                        style={["simple"]}
                        onChange={onRomChange}
                    />
                }
            />
            <Pair
                key="rom-count"
                name={"Available"}
                value={`${roms.length} ROMs`}
            />
        </Info>
    );
};
